export default __webpack_public_path__ + "static/media/Blood Scripture of Xotli.214b6b35.jpg";